var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.product
    ? _c(
        "div",
        { staticClass: "overlay-product" },
        [
          _c("div", { staticClass: "overlay-product__details" }, [
            _c(
              "div",
              { staticClass: "overlay-product__images" },
              [
                _c("button", {
                  ref: "message",
                  staticClass: "overlay-product__message",
                  class: { "overlay-product__message--added": _vm.addedToCart },
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("shoplist.product.successCart")),
                  },
                  on: { click: _vm.onCloseMessage },
                }),
                _vm._v(" "),
                _vm.showImageGrid
                  ? _c(
                      "ul",
                      {
                        staticClass: "overlay-product__images-grid",
                        class: [
                          "overlay-product__images-grid--" +
                            Math.min(_vm.product.imagesDetail.length, 3),
                        ],
                      },
                      _vm._l(
                        _vm.product.imagesDetail.slice(0, 3),
                        function (image, index) {
                          return _c(
                            "li",
                            {
                              key: "product-image-" + index,
                              staticClass: "overlay-product__images-item",
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "overlay-product__images-item-image",
                                attrs: {
                                  src: image,
                                  alt: "Product Image",
                                  "data-object-fit": "",
                                  loading: "lazy",
                                },
                              }),
                            ]
                          )
                        }
                      ),
                      0
                    )
                  : _c(
                      "vue-glide",
                      _vm._b(
                        {
                          ref: "glide",
                          staticClass: "overlay-product__images-slider",
                          class: {
                            "overlay-product__images-slider--disabled":
                              this.product.imagesDetail.length <= 1,
                          },
                        },
                        "vue-glide",
                        _vm.glideOptions,
                        false
                      ),
                      _vm._l(_vm.product.imagesDetail, function (image, index) {
                        return _c(
                          "vue-glide-slide",
                          {
                            key: "product-image-slide-" + index,
                            staticClass: "overlay-product__images-slide",
                          },
                          [
                            _c("img", {
                              ref: "image",
                              refInFor: true,
                              staticClass:
                                "overlay-product__images-slide-image",
                              attrs: {
                                src: image,
                                alt: "Product Image",
                                "data-object-fit": "",
                                loading: "lazy",
                              },
                            }),
                          ]
                        )
                      }),
                      1
                    ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "overlay-product__info",
                class: [_vm.bgColorClass],
              },
              [
                _c("div", { staticClass: "overlay-product__controls" }, [
                  _c("a", {
                    staticClass: "overlay-product__back-button",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("shoplist.product.continueShopping")
                      ),
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$emit("close")
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "overlay-product__close",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_c("SVGClose")],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "overlay-product__info-content",
                    class: [_vm.bgColorClass],
                  },
                  [
                    _c(
                      "h1",
                      { staticClass: "overlay-product__title" },
                      [
                        _c("span", {
                          staticClass: "overlay-product__title-name",
                          domProps: { innerHTML: _vm._s(_vm.product.name) },
                        }),
                        _vm._v(" "),
                        _vm.product.isVegetarian || _vm.product.isVegan
                          ? _c("SVGLabelLeaf", {
                              staticClass: "products__item-title-label",
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.product.isVegan
                          ? _c("SVGLabelLeaf", {
                              staticClass: "products__item-title-label",
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.product.description || _vm.product.shortDescription
                      ? _c("div", {
                          staticClass: "overlay-product__description",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.product.description ||
                                _vm.product.shortDescription
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.product.consumption || _vm.product.steamtime
                      ? _c(
                          "ul",
                          { staticClass: "overlay-product__preparation" },
                          [
                            _vm.product.consumption
                              ? _c(
                                  "li",
                                  {
                                    staticClass:
                                      "overlay-product__preparation-item",
                                  },
                                  [
                                    _c("SVGDumplingSticks", {
                                      staticClass:
                                        "overlay-product__preparation-item-icon",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "overlay-product__preparation-item-content",
                                      },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "overlay-product__preparation-item-text",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.product.consumption
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.product.steamtime
                              ? _c(
                                  "li",
                                  {
                                    staticClass:
                                      "overlay-product__preparation-item",
                                  },
                                  [
                                    _c("SVGDumplingsBasket", {
                                      staticClass:
                                        "overlay-product__preparation-item-icon",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "overlay-product__preparation-item-content",
                                      },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "overlay-product__preparation-item-text",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.product.steamtime
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.$te(
                                          "shoplist.product.steamTimeLinkText"
                                        ) &&
                                        _vm.$te(
                                          "shoplist.product.steamTimeLinkUrl"
                                        )
                                          ? _c("Button", {
                                              staticClass:
                                                "overlay-product__preparation-item-button",
                                              attrs: {
                                                level: "tertiary",
                                                text: _vm.$t(
                                                  "shoplist.product.steamTimeLinkText"
                                                ),
                                                href: _vm.$t(
                                                  "shoplist.product.steamTimeLinkUrl"
                                                ),
                                                target: "_blank",
                                                arrow: "",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.product.nutritionInfos
                      ? _c(
                          "Collapsible",
                          {
                            staticClass: "overlay-product__nutrition",
                            attrs: { "initial-open": false },
                          },
                          [
                            _c("template", { slot: "trigger" }, [
                              _c("h2", {
                                staticClass: "overlay-product__nutrition-title",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("shoplist.product.nutritional")
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "overlay-product__nutrition-infos",
                              domProps: {
                                innerHTML: _vm._s(_vm.product.nutritionInfos),
                              },
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.product.isNewFlavour
                      ? _c("div", {
                          staticClass: "overlay-product__new",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("shoplist.product.newFlavour")
                            ),
                          },
                        })
                      : _vm.product.isPlanted
                      ? _c("div", { staticClass: "overlay-product__planted" }, [
                          _c("img", {
                            staticClass: "overlay-product__planted-label",
                            attrs: {
                              src: _vm.productLabelPath("planted"),
                              alt: "planted label",
                            },
                          }),
                        ])
                      : _vm.product.isLimited
                      ? _c("div", {
                          staticClass: "overlay-product__limited",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("shoplist.product.limitedEdition")
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "overlay-product__price" },
                      [
                        _vm.originalPrice
                          ? _c("strike", {
                              staticClass: "overlay-product__price-old",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$options.filters.madpricecent(
                                    _vm.originalPrice
                                  )
                                ),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "overlay-product__price-current",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$options.filters.madpricecent(_vm.price)
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _vm.product.unit
                          ? _c("span", {
                              staticClass: "overlay-product__price-unit",
                              domProps: { innerHTML: _vm._s(_vm.product.unit) },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.hasBasket
                  ? _c(
                      "div",
                      { staticClass: "overlay-product__cart" },
                      [
                        !_vm.product.isEditable
                          ? _c("QuantityCounter", {
                              class: {
                                "overlay-product__quantity--soldout":
                                  !_vm.isAvailable,
                              },
                              attrs: {
                                quantity: _vm.quantity,
                                "base-class": "overlay-product__quantity",
                                locked: !_vm.isAvailable,
                              },
                              on: {
                                sub: function ($event) {
                                  return _vm.onSub()
                                },
                                add: function ($event) {
                                  return _vm.onAdd()
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("Button", {
                          staticClass: "overlay-product__cart-button",
                          class: {
                            "overlay-product__cart-button--soldout":
                              !_vm.isAvailable,
                            "btn--no-animation": !_vm.isAvailable || _vm.locked,
                          },
                          attrs: {
                            level: "primary",
                            type: "button",
                            text: _vm.isAvailable
                              ? _vm.$t("shoplist.product.add")
                              : _vm.$t("shoplist.product.soldOut"),
                            disabled: _vm.locked || !_vm.isAvailable,
                            variants: ["small"],
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onCart()
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.crossSell
            ? _c("ProductCrossSell", { attrs: { products: _vm.crossSell } })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }